module.exports = __webpack_public_path__ + "bin/45a8b068041ea95b6d9586e7ad4aea14.svg";